import React, { useState, useEffect } from 'react';
import { profilApi } from '../api';

const card = { background: '#1e293b', borderRadius: 12, padding: 24, marginBottom: 20 };
const label = { display: 'block', marginBottom: 6, color: '#94a3b8', fontSize: 13 };
const input = {
  width: '100%', padding: '8px 12px', background: '#0f172a', border: '1px solid #334155',
  borderRadius: 8, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box',
};

export default function ProfilPage() {
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [profilMsg, setProfilMsg] = useState(null);
  const [profilError, setProfilError] = useState(null);
  const [altPass, setAltPass] = useState('');
  const [neuPass, setNeuPass] = useState('');
  const [passMsg, setPassMsg] = useState(null);
  const [passError, setPassError] = useState(null);

  useEffect(() => {
    profilApi.me().then(r => {
      setUser(r);
      setName(r.name || '');
      setEmail(r.email || '');
    });
  }, []);

  async function saveProfil(e) {
    e.preventDefault();
    setProfilMsg(null); setProfilError(null);
    try {
      const r = await profilApi.update({ name, email });
      setUser(r);
      setProfilMsg('Profil gespeichert.');
    } catch (err) {
      setProfilError(err.response?.data?.error || 'Fehler beim Speichern');
    }
  }

  async function savePasswort(e) {
    e.preventDefault();
    setPassMsg(null); setPassError(null);
    if (neuPass.length < 8) { setPassError('Neues Passwort muss mindestens 8 Zeichen haben'); return; }
    try {
      await profilApi.changePassword({ altes_passwort: altPass, neues_passwort: neuPass });
      setPassMsg('Passwort geändert.');
      setAltPass(''); setNeuPass('');
    } catch (err) {
      setPassError(err.response?.data?.error || 'Fehler beim Ändern');
    }
  }

  if (!user) return <div style={{ padding: 32, color: '#94a3b8' }}>Lädt…</div>;

  return (
    <div style={{ padding: 32, maxWidth: 600 }}>
      <h1 style={{ color: '#f1f5f9', marginBottom: 24 }}>Profil</h1>

      <div style={card}>
        <h2 style={{ color: '#f1f5f9', fontSize: 16, marginBottom: 16 }}>Persönliche Daten</h2>
        <form onSubmit={saveProfil}>
          <div style={{ marginBottom: 14 }}>
            <label style={label}>Name</label>
            <input style={input} value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={label}>E-Mail</label>
            <input style={input} type="email" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          {profilMsg && <div style={{ color: '#22c55e', marginBottom: 8, fontSize: 13 }}>{profilMsg}</div>}
          {profilError && <div style={{ color: '#f87171', marginBottom: 8, fontSize: 13 }}>{profilError}</div>}
          <button type="submit" className="btn-primary">Speichern</button>
        </form>
      </div>

      <div style={card}>
        <h2 style={{ color: '#f1f5f9', fontSize: 16, marginBottom: 16 }}>Passwort ändern</h2>
        <form onSubmit={savePasswort}>
          <div style={{ marginBottom: 14 }}>
            <label style={label}>Aktuelles Passwort</label>
            <input style={input} type="password" value={altPass} onChange={e => setAltPass(e.target.value)} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={label}>Neues Passwort (min. 8 Zeichen)</label>
            <input style={input} type="password" value={neuPass} onChange={e => setNeuPass(e.target.value)} />
          </div>
          {passMsg && <div style={{ color: '#22c55e', marginBottom: 8, fontSize: 13 }}>{passMsg}</div>}
          {passError && <div style={{ color: '#f87171', marginBottom: 8, fontSize: 13 }}>{passError}</div>}
          <button type="submit" className="btn-primary">Passwort ändern</button>
        </form>
      </div>

      <div style={card}>
        <h2 style={{ color: '#f1f5f9', fontSize: 16, marginBottom: 8 }}>Konto-Info</h2>
        <div style={{ color: '#94a3b8', fontSize: 13 }}>
          <div>ID: {user.id}</div>
          <div>E-Mail: {user.email}</div>
          <div style={{ marginTop: 8, color: '#475569' }}>
            Zugangsdaten werden verschlüsselt gespeichert (bcrypt). Keine Daten werden an Dritte weitergegeben.
          </div>
        </div>
      </div>
    </div>
  );
}
